@let isLoading = this.isLoading();
@let isSyncInProgress = this.isSyncInProgress();
@let menus = this.menus();
@let current = this.currentMenu();
@let tableName = this.tableName();

<app-page-header
  class="header"
  [backSwipe]="currentMenu() ? backSwipeConfig : undefined"
  [tableName]="tableName"
  [backButtonRouterLink]="['/main', 'home']"
/>

@if (isLoading || isSyncInProgress) {
  <app-loading/>
} @else if (!menus || menus.length === 0) {
  <div class="empty">
    No menu available at this time.
  </div>
} @else {
  <div class="title">
    <span class="big">Menu</span>
    <span class="description">Enjoy a menu offering hand-selected, local and seasonal ingredients created by our Executive Chef, EVAN TANDY</span>
  </div>

  <div class="categories" coreActivitySection="MenuCategories">
    @for (menu of menus; track menu.id) {
      <button
        class="category"
        [coreUserActivityClickTracking]="menu.name.split(' ').join('') + 'Open'"
        (click)="currentMenu.set(menu)"
      >
        @if (!menu.happyHours) {
          {{ menu.name }}
        } @else {
          <svg class="happy-hours" width="90" height="13" viewBox="0 0 90 13" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M58.35 0 53.27 8.325v4.45h-5.58V8.288L42.757 0h6.137l1.991 3.817L52.787 0h5.562ZM43.12 4.604c0 2.283-1.56 4.182-4.718 4.182h-2.835v3.99h-5.598V0h8.325c3.176 0 4.826 1.784 4.826 4.048v.556Zm-5.598.499v-.518c0-.633-.269-.94-1.04-.94h-.915v2.417h.915c.771 0 1.04-.345 1.04-.96ZM28.766 4.604c0 2.283-1.561 4.182-4.719 4.182h-2.835v3.99h-5.598V0h8.325c3.176 0 4.827 1.784 4.827 4.048v.556Zm-5.598.499v-.518c0-.633-.27-.94-1.04-.94h-.916v2.417h.915c.772 0 1.04-.345 1.04-.96ZM15.06 12.776H9.32l-.593-2.13h-3.14l-.664 2.13H.007L4.583 0h5.849l4.629 12.776ZM7.993 7.884 7.31 5.141l-.808 2.743h1.49Z"
              fill="#FFEED4"/>
            <path class="hour"
                  d="M89.057 12.72h-2.24c-.419 0-.629-1.086-.629-1.927V8.51c0-.318-.192-.711-.577-.711h-.613v4.92h-2.694V.261h3.78c1.311 0 2.588.935 2.588 2.618v2.17c0 .617-.385 1.29-1.084 1.646.7.356 1.137 1.01 1.137 1.665v2.282c0 .786.157 1.422.332 2.02v.056Zm-2.939-7.576v-2.02c0-.43-.157-.599-.455-.599h-.665v3.217h.665c.298 0 .455-.168.455-.598ZM81.385 9.913c0 1.721-1.313 3.087-3.22 3.087-1.872 0-3.306-1.366-3.306-3.087V.262h2.712v9.651c0 .393.28.618.594.618.35 0 .63-.225.63-.618V.262h2.59v9.651ZM74.011 9.745c0 1.946-1.47 3.255-3.36 3.255-1.906 0-3.376-1.31-3.376-3.255V3.236c0-1.927 1.47-3.236 3.377-3.236 1.89 0 3.359 1.31 3.359 3.236v6.51Zm-2.747.169V3.068c0-.393-.28-.618-.612-.618-.332 0-.63.225-.63.618v6.846c0 .392.297.617.63.617.332 0 .612-.225.612-.617ZM66.42 12.72h-2.678V7.967h-1.574v4.751h-2.694V.262h2.694v5.162h1.574V.262h2.677v12.457Z"
                  fill="#E31E38"/>
          </svg>
        }
      </button>
    }
  </div>

  <div class="link">
    <app-qrcode
      class="qrcode"
      content="https://oon.gl/fhW3EX"
      [size]="230"
    />
    <div class="text">
      Scan qr to<br>access the menu<br>on your phone
    </div>
  </div>
}

@if (menus && menus.length > 0 && current) {
  <app-menu-detail
    @InOutAnimation
    class="full-page"
    [menus]="menus"
    [current]="current"
    (back)="currentMenu.set(null)"
  />
}
